import type { Painter } from './paint';
import { STUDIO } from './studio-ui';

/** Shared ten-color preview, always bounded to five columns and two rows. */
export function palettePreview(p:Painter,colors:readonly string[],x:number,y:number,w:number,h:number){
  const gap=3,cols=5,rows=Math.ceil(colors.length/cols),cw=(w-gap*(cols-1))/cols,ch=(h-gap*(rows-1))/rows;
  colors.forEach((color,i)=>p.box(x+i%cols*(cw+gap),y+Math.floor(i/cols)*(ch+gap),cw,ch,color,Math.min(7,ch/3),color.toUpperCase()==='#FFFFFF'?STUDIO.line:undefined));
}
